module.exports = __webpack_public_path__ + "static/15gde-14050a0fc86f90b8d755a6f25e0f2274.gif";